export default __webpack_public_path__ + "static/dfwlab_photo_coming_soon_2022-cde303310f26de65090bb518ff9bafc7.jpg";